// Janela de notas carregadas no boot (#396, #400): o mês de 3 meses atrás até hoje.
// Em out/2026 começa em 01/07/2026. O Dashboard amplia os indicadores até MESES_MAX. Notas mais antigas vêm sob demanda, em
// períodos de até MAX_DIAS_PERIODO dias.
export const MESES_JANELA = 3;
export const MESES_MAX = 12;
export const MAX_DIAS_PERIODO = 30;

/** Hoje em "AAAA-MM-DD", no fuso de São Paulo. */
export const hojeSP = () => new Date().toLocaleDateString("sv-SE", { timeZone: "America/Sao_Paulo" });

/** "AAAA-MM-DD" do dia 1 do mês que fica `meses` meses antes de `hojeISO`. */
export function inicioJanela(hojeISO, meses = MESES_JANELA) {
  const [a, m] = hojeISO.split("-").map(Number);
  return new Date(Date.UTC(a, m - 1 - meses, 1)).toISOString().slice(0, 10);
}

/** Mensagem de erro do período pedido (datas "AAAA-MM-DD"), ou null se vale. */
export function erroDoPeriodo(de, ate) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(de || "") || !/^\d{4}-\d{2}-\d{2}$/.test(ate || "")) return "Informe a data inicial e a final.";
  if (de > ate) return "A data inicial vem depois da final.";
  const dias = (Date.parse(ate) - Date.parse(de)) / 86_400_000 + 1;
  return dias > MAX_DIAS_PERIODO ? `O período vai até ${MAX_DIAS_PERIODO} dias por vez (pediu ${dias}).` : null;
}
